import { answersPageActionTypes } from './actionTypes/answersPage';
import { AnswerQueryInterface } from '@types';
import { makeAllAnswers, setCheckedAnswers } from '@actions/answerActions';
import { notAppliedAnswersFilters } from '@constants/answers';
import _cloneDeep from 'lodash/cloneDeep';

export const setIsOpenAnswersDeleteModal = (isOpen: boolean) => {
  return {
    type: answersPageActionTypes.SET_IS_OPEN_ANSWERS_DELETE_MODAL,
    payload: isOpen,
  };
};

export const setIsOpenMarkAsSentModal = (isOpen: boolean) => {
  return {
    type: answersPageActionTypes.SET_IS_OPEN_MARK_AS_SENT_MODAL,
    payload: isOpen,
  };
};

export const setAnswerFiltersPartially = (
  query?: Partial<AnswerQueryInterface>,
  keepCheckboxes?: boolean
) => {
  return (dispatch, getState) => {
    const store = getState();
    const filters = store.answersPage.filters;

    const updatedQuery = { ...filters, ...query };

    if (!query?.offset) {
      updatedQuery.offset = 0;
    }
    dispatch({
      type: answersPageActionTypes.SET_ANSWERS_FILTERS,
      payload: _cloneDeep(updatedQuery),
    });

    if (!keepCheckboxes) {
      dispatch(setCheckedAnswers([]));
    }
    dispatch(makeAllAnswers(updatedQuery));
  };
};

export const resetAnswerFilters = () => {
  return (dispatch) => {
    dispatch({
      type: answersPageActionTypes.SET_ANSWERS_FILTERS,
      payload: _cloneDeep(notAppliedAnswersFilters),
    });

    dispatch(setCheckedAnswers([]));
    dispatch(makeAllAnswers(notAppliedAnswersFilters));
  };
};
